import { render } from "./menuitem.vue?vue&type=template&id=585b3ec8"
import script from "./menuitem.vue?vue&type=script&lang=ts"
export * from "./menuitem.vue?vue&type=script&lang=ts"
script.render = render

export default script